(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["snip_blur_overlay"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const blurOverlay = document.querySelector('.blur-overlay');
    if (!blurOverlay) return;
    
    let ticking = false;
    
    function handleScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          updateBlurOpacity();
          ticking = false;
        });
        ticking = true;
      }
    }
    
    function updateBlurOpacity() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = Math.max(
        document.body.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.clientHeight,
        document.documentElement.scrollHeight,
        document.documentElement.offsetHeight
      );

      // Calculate max scroll position
      const maxScroll = documentHeight - windowHeight;
      
      // Fade distance is 100px (same as blur overlay height)
      const fadeDistance = 100;
      
      // Calculate fade start point
      const fadeStartScroll = maxScroll - fadeDistance;
      
      let opacity = 1;
      
      if (scrollTop >= fadeStartScroll) {
        // Map scroll position from fadeStartScroll to maxScroll into opacity 1 to 0
        const progress = (scrollTop - fadeStartScroll) / fadeDistance;
        opacity = Math.max(0, 1 - progress);
      }
      document.querySelector('.blur-overlay-inner').style.setProperty('--blur-factor', opacity);
    }
    
    // Add scroll listener
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // Initial check
    if ('requestIdleCallback' in window) {
      requestIdleCallback(updateBlurOpacity, { timeout: 2000 });
    } else {
      setTimeout(updateBlurOpacity, 1000);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
